<template>
  <div class="playerContainer">
    <video
      ref="courseVideo"
      :controls="played"
      preload="auto"
      x-webkit-airplay="allow"
      x5-video-player-type="h5"
      airplay="allow"
      x5-playsinline="true"
      playsinline
      webkit-playsinline
      x5-video-player-fullscreen="true"
      crossorigin="anonymous"
      :poster="poster"
    >
      <slot />
    </video>
    <div class="bg" v-if="!played">
      <div class="btn" @click.stop="getVideo"></div>
    </div>
  </div>
</template>

<script>
import { isLogin, userLogin } from '@/widget/index'
import { appPort } from '@/widget/index'
import { defineComponent } from 'vue'
import { getVideoUrl } from '@/api/video'
import Hls from 'hls.js'
export default defineComponent({
  props: {
    videoUrl: {
      default: '',
      type: String
    },
    poster: {
      default: '',
      type: String
    },
    videoId: {
      default: '',
      type: String
    },
    login: {
      default: false,
      type: Boolean
    },
    permission: {
      default: false,
      type: Boolean
    },
    calendar: {
      default: false, // 是否是日历页
      type: Boolean
    }
  },
  data() {
    return {
      videoSrc: '',
      played: false,
      hls: null,
      styleFl: {
        'background-image': 'url(' + this.poster + ')',
        'background-size': '100% 100%',
        'background-repeat': 'no-repeat'
      },
      isApp: appPort()
    }
  },
  methods: {
    playVideo() {
      if (this.login && !isLogin) {
        userLogin()
        return
      }
      this.played = true
      this.$refs.courseVideo.play()
    },
    getVideo() {
      var val = this.videoId
      if (!val) {
        this.$toast('视频播放ID无效')
        return
      }
      /* app中判断是否有观看权限 */
      if (this.isApp && !this.permission && this.calendar) {
        this.$emit('isShow')
        return
      }
      if (this.videoUrl) {
        // 传入视频播放地址时，直接播放视频
        this.playVideo()
        return
      }
      // 传入video hash值时，获取播放地址
      getVideoUrl({
        params: {
          videoId: val
        }
      })
        .then(res => {
          if (Number(res.code) === 200) {
            this.videoSrc = res.data.ssl_url
          }
        })
        .catch(error => {
          console.log(error)
        })
    }
  },
  watch: {
    videoUrl(newData) {
      if (newData) {
        this.videoSrc = newData
      }
    },
    videoSrc(newData) {
      const video = this.$refs.courseVideo
      if (newData) {
        if (!video) return false
        if (video && video.canPlayType('application/vnd.apple.mpegurl')) {
          video.src = newData
        } else if (Hls.isSupported()) {
          if (!this.hls) {
            this.hls = new Hls()
          }
          this.hls.loadSource(newData)
          this.hls.attachMedia(video)
        }
        if (!this.videoUrl) {
          this.playVideo()
        }
      } else {
        video.src = newData
      }
    },
    videoId(n) {
      this.played = false
      this.hls && this.hls.stopLoad()
      this.videoSrc = ''
    }
  }
})
</script>

<style lang="scss" scoped>
.playerContainer {
  width: 100%;
  position: relative;
  video {
    width: 100%;
    height: 340px;
    object-fit: cover;
    border-radius: 12px;
  }
  .btn {
    width: 120px;
    height: 120px;
    background-image: url('~@/assets/icon/playbtn.png');
    background-size: 120px 120px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -60px;
    margin-top: -60px;
  }
}
.bg {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
</style>
